module.exports = __webpack_public_path__ + "static/media/shakishaki_logo_RVB_blanc.27911bf9.png";